export default "__VITE_ASSET__CTVKi$Ix__"